// assets
import { CalendarOutlined, ShopOutlined, ShoppingOutlined, BarChartOutlined } from '@ant-design/icons';
import { reactLocalStorage } from 'reactjs-localstorage';

// icons
const icons = {
  CalendarOutlined,
  ShopOutlined,
  ShoppingOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

const pagesPo = {
  id: 'pages-po',
  title: 'PO',
  type: 'group',
  children: [
    {
        id: 'po-product',
        title: 'PO Product',
        type: 'item',
        url: '/product-po',
        icon: icons.ShopOutlined,
        breadcrumbs: true
        // target: true
    },
    {
        id: 'po',
        title: 'PO',
        type: 'item',
        url: '/po',
        icon: icons.ShopOutlined,
        breadcrumbs: true
        // target: true
    },
  ]
};

export default pagesPo;
